<template>
	<div>
		<div class="main flex-shrink flex-wrap flex-col">
			<div
				class="bg-gray-300 rounded flex flex-shrink col-span-3 p-8 flex-col mb-6 cursor-pointer"
				@click="
					$router.push({
						name: 'management.process.create_comprehensive',
						query: { customer_id: $route.query.customer_id, vehicle_id: $route.query.vehicle_id },
						params: { backlink: $route },
					})
				"
			>
				<div class="font-bold flex flex-shrink mb-3">{{ $t('own_damage_comprehensive') }}</div>
				<div class="flex flex-wrap">
					{{ $t('comprehensive_info') }}
				</div>
			</div>
			<div
				class="bg-gray-300 rounded flex-shrink flex col-span-3 p-8 flex-col mb-6 cursor-pointer"
				@click="
					$router.push({
						name: 'management.process.create',
						query: { customer_id: $route.query.customer_id, vehicle_id: $route.query.vehicle_id },
						params: { backlink: $route },
					})
				"
			>
				<div class="font-bold flex flex-shrink mb-3">{{ $t('liability') }}</div>
				<div class="flex flex-wrap">
					{{ $t('liability_info') }}
				</div>
			</div>
			<div
				class="bg-gray-300 rounded flex flex-shrink col-span-3 p-8 flex-col mb-6 cursor-pointer"
				@click="
					$router.push({
						name: 'management.process.order_documentation',
						query: { customer_id: $route.query.customer_id, vehicle_id: $route.query.vehicle_id },
						params: { backlink: $route },
					})
				"
			>
				<div class="font-bold flex flex-shrink mb-3">{{ $t('order_documentation') }}</div>
				<div class="flex flex-wrap">
					{{ $t('order_documentation_info') }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Validate from '@/mixins/Validate';
import Authentication from '@/mixins/Authentication';
import AppContainerMixin from '@/mixins/AppContainerMixin';

export default {
	name: 'InformationModal',
	mixins: [Validate, Authentication, AppContainerMixin],
	mounted() {
		if (!(this.isUserAllowedInLevel5or6 && this.isAppContainer)) {
			this.$emit('authNotAllowed');
		}
	},
};
</script>

<style scoped></style>
